import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { MacDock } from './MacDock';
import { AlertToasts } from './AlertToasts';

export const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FBF9F5] dark:bg-[#111215] text-neutral-800 dark:text-neutral-100 transition-colors duration-200">
      {/* Top Navigation Bar */}
      <TopBar />

      {/* macOS Style Left Navigation Dock */}
      <MacDock />

      {/* Middle Content Area */}
      <main className="flex-1 w-full mx-auto px-2 sm:px-4 py-0.5 pl-14 sm:pl-16 pb-0.5">
        <Outlet />
      </main>

      {/* a pop-up from the bottom for every new alert (AlertToasts.tsx) */}
      <AlertToasts />
    </div>
  );
};
